var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app--proton-btn app--btn",class:_vm.isDraggable ? 'app--btn-draggable' : '',attrs:{"data-type":"p"}},[_vm._v("P")])}
var staticRenderFns = []

export { render, staticRenderFns }